module.exports = __webpack_public_path__ + "img/Listening_to_mic.20cc0e99.gif";